import { FormikProvider, useFormik } from 'formik';
import { Input } from '../form';
import { SearchInputPropsModel } from './search-input-props.model';
import { Icon } from '../UI';
import React, { useEffect } from 'react';

const SearchInput = (props: SearchInputPropsModel) => {
  const formik = useFormik({
    initialValues: {
      search: '',
    },
    onSubmit: (values) => {},
    validateOnMount: true,
  });

  useEffect(() => {
    formik.setFieldValue('search', props.value);
  }, [props.value]);

  const handleChange = (_, value) => {
    if (props.onChange) {
      props.onChange(value);
    }
  };

  const handleKeyUp = (e) => {
    if (props.onKeyUp) {
      props.onKeyUp(e);
    }
  };

  return (
    <FormikProvider value={formik}>
      <div
        className={`flex items-center pl-5 -mb-2.5 ${
          props.size === 'full' ? 'w-full' : 'w-auto'
        }`}
      >
        <Icon
          className="text-black pointer-events-none mb-2 mr-1"
          color="black"
          svgName={'search'}
        />
        <Input
          size={props.size || 'small'}
          className="pl-1 bg-white dark:bg-grey-90 border-none"
          name="search"
          id="search"
          formik={formik}
          type="text"
          placeholder={props.placeholder ?? 'Search'}
          onChange={handleChange}
          onKeyUp={handleKeyUp}
          value={props.value}
        />
      </div>
    </FormikProvider>
  );
};

export default SearchInput;
